<script>
import { getAuth } from 'firebase/auth';
import { getEmailCampaignView } from '../../js/readModel.js';
import { showConfirm } from '../../js/utils/confirm.js';

export const pageName = 'admin-email-campaigns-view';
export const pageRoute = '/admin/email-campaigns/{campaignId}/view';
export const title = 'View campaign'
export const requireAdmin = true;

export default {
	data() {
		return {
			campaign: null
		}
	},
	methods: {
		boot(opts)
		{
			window.addEventListener('message', e => {
				if(e.origin != window.location.origin)
					return;

				if(e.data?.type != 'email-campaign-link-view')
					return;

				let linkId = e.data.linkId;

				showConfirm({
					'title': 'View link interactions',
					message: JSON.stringify(this.campaign.getLinkInteractions(linkId), null, '\t'),
					buttons: []
				})
			})
		},
		async show(opts)
		{
			this.campaign = await getEmailCampaignView(opts.campaignId)
			let token = await getAuth().currentUser.getIdToken()
			this.$refs.preview.src = '/api/email-campaigns/preview?campaignId=' + encodeURIComponent(opts.campaignId) + '&token=' + encodeURIComponent(token);
		}
	}
}
</script>
<template>
<div class="container">
    <form @submit.prevent="submit" @change="changed">
		<div class="row justify-content-center py-5">
			<div class="col-12 col-md-8">
				
				<h1 class="display-4 text-center mb-3">View campaign</h1>
				<p class="text-muted text-center mb-5">See how your campaign performed</p>

				<div class="card">
					<div class="card-header">
						<h4 class="card-header-title">Stats</h4>
					</div>
					<div class="card-body">
						<div class="list-group list-group-flush my-n3">
							<div class="list-group-item">
								<div class="row">
									<div class="col">
										Sends
									</div>
									<div class="col">
										{{ campaign?.recipientCount}}
									</div>
								</div>
							</div>
							<div class="list-group-item">
								<div class="row">
									<div class="col">
										Deliveries
									</div>
									<div class="col">
										{{ campaign?.totalDeliveries }}
									</div>
								</div>
							</div>
							<div class="list-group-item">
								<div class="row">
									<div class="col">
										Opens
									</div>
									<div class="col">
										{{ campaign?.totalOpens }}
									</div>
								</div>
							</div>
							<div class="list-group-item">
								<div class="row">
									<div class="col">
										Bounces
									</div>
									<div class="col">
										{{ campaign?.totalBounces }}
									</div>
								</div>
							</div>
							<div class="list-group-item">
								<div class="row">
									<div class="col">
										Complaints
									</div>
									<div class="col">
										{{ campaign?.totalComplaints }}
									</div>
								</div>
							</div>
							<div class="list-group-item">
								<div class="row">
									<div class="col">
										Interactions
									</div>
									<div class="col">
										{{ campaign?.totalInteractions }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>


				<div class="card no-overflow">
					<div class="card-header">
						<h4 class="card-header-title">Preview</h4>
					</div>
					<div class="card-body p-0" style="line-height: 1px;">
						<iframe ref="preview" class="w-100" style="height: 50vh; border: 0"></iframe>
					</div>
				</div>

				<div class="card">
					<div class="card-header">
						<h4 class="card-header-title">Recipients</h4>
					</div>
					<table class="table card-table">
						<thead>
							<tr>
								<th>Email</th>
								<th>Delivered</th>
								<th>Bounced</th>
								<th>Complained</th>
								<th>Opened</th>
								<th>Clicks</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="result in campaign?.results">
								<td><a :href="`/admin/user/${result.userId}`">{{ result.email }}</a></td>
								<td class="text-center">{{ !!result.deliveredOn ? 'Yes' : 'No' }}</td>
								<td class="text-center">{{ !!result.bouncedOn ? 'Yes' : 'No' }}</td>
								<td class="text-center">{{ !!result.complainedOn ? 'Yes' : 'No' }}</td>
								<td class="text-center">{{ !!result.opens.length ? 'Yes' : 'No' }}</td>
								<td class="text-right">{{ result.linkClicks.length }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</form>
</div>
</template>